import React, {useState, useEffect} from 'react';
import api from "../../api/api";
import './ReplicationDot.css'
import PasswordModal from "../dialog_modal/passwordmadal";
import {store} from "../../store/store";

const ReplicationDot = () => {
    const [isHealthy, setIsHealthy] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [password, setPassword] = React.useState(0);

    const checkStatus = async () => {
        try {
            const {data} = await api().get('/replication-simple', {
                timeout: 4000,
            });
            setIsHealthy(data.is_healthy);
        } catch {
            setIsHealthy(false);
        }
    };

    useEffect(() => {
        checkStatus();
        const interval = setInterval(checkStatus, 10000);
        return () => clearInterval(interval);
    }, []);

    const restartReplication = async () => {
        await store.setting_sorev.restartReplication(password);
        setOpenDialog(false);
    }

    return (
        <>
            {isHealthy !== null && (
                isHealthy ? (
                    <div
                        className="replication-dot green"
                        title="Репликация работает"
                    >
                        Replication
                    </div>
                ) : (
                    <div
                        className="replication-dot red"
                        title="Проблема с репликацией"
                        onClick={() => {
                            setOpenDialog(true);
                        }}
                    >
                        Replication
                    </div>
                )
            )}
            <PasswordModal
                title="Восстановить репликацию?" status="Внимание! При восстановлении репликации, запрещена модификация данных программы!"
                open={openDialog} setOpen={setOpenDialog} setPassword={setPassword} handlerConfirm={restartReplication}/>
        </>
    );
};

export default ReplicationDot;